import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
import ProductStoreStatisticalInfo from '../entities/productstore-statistical'
import appconst from '@/lib/appconst';

//BackProductStoreStatisticalList

interface ProductStoreStatisticalInfoState extends ListState<ProductStoreStatisticalInfo> {
    ProductStoreStatisticalInfo: ProductStoreStatisticalInfo,
}

class ProductStoreStatisticalInfoMutations extends ListMutations<ProductStoreStatisticalInfo>{

}
class ProductStoreStatistical extends ListModule<ProductStoreStatisticalInfoState, any, ProductStoreStatisticalInfo>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<ProductStoreStatisticalInfo>(),
        loading: false,
        PackStatisticalInfo: ProductStoreStatisticalInfo,
        shopid: 0

    }
    actions = {
        async getAll(context: ActionContext<ProductStoreStatisticalInfoState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/StatisticalRecords/GetProductStoreStatisticalList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<ProductStoreStatisticalInfo>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        }
    };
    mutations = {
        setCurrentPage(state: ProductStoreStatisticalInfoState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: ProductStoreStatisticalInfoState, pagesize: number) {
            state.pageSize = pagesize;
        }

    }
}

const productStoreStatistical = new ProductStoreStatistical();
export default productStoreStatistical;